import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import { routes } from "./Routes";
import Layout from "../Layout/Layout";
import { NotFound } from "../Pages/NotFound";
import CurrentUserProfile from "../Pages/CurrentUserProfile";
import Support from "../Pages/Support";
import ChangePassword from "../Pages/ChangePassword";
import EditProfile from "../Pages/CurrentUserProfile/EditProfile";
import ChangeEmail from "../Pages/ChangeEmail";
import usePermissions from "@/utils/hooks/usePermissions";
import { NoAccess } from "@/CommonElements/NoAccess";

const LayoutRoutes = () => {
  const { canAccessMakkah, canAccessUserManagement, canAccessSeasonalHR, canAccessMadina } = usePermissions();
  return (
    <>
      <Routes>
        {/* Systems Routes */}
        <Route element={<Layout />}>
          {canAccessMakkah() ? routes.makkah.map(({ path, Component }) => (
            <Route path={path} element={Component} key={path} />
          )) : <Route path="*" element={<NoAccess />} key="*" />}
          {canAccessUserManagement() ? routes["user_management"].map(({ path, Component }) => (
            <Route path={path} element={Component} key={path} />
          )) : <Route path="*" element={<NoAccess />} key="*" />}
          {canAccessSeasonalHR() ? routes["seasonal_hr"].map(({ path, Component }) => (
            <Route path={path} element={Component} key={path} />
          )) : <Route path="*" element={<NoAccess />} key="*" />}

          {canAccessMadina() ? routes.madina.map(({ path, Component }) => (
            <Route path={path} element={Component} key={path} />
          )) : <Route path="*" element={<NoAccess />} key="*" />}

          {/* **** User Profile **** */}
          <Route path="me" element={<Outlet />}>
            <Route index element={<CurrentUserProfile />} />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="edit" element={<EditProfile />} />
            <Route path="change-email" element={<ChangeEmail />} />
          </Route>

          {/* **** Support **** */}
          <Route path="support" element={<Support />} />

          {/* **** Not Found **** */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
};

export default LayoutRoutes;
